export function validarCPF(cpf: string): boolean {
  // Remover caracteres não numéricos
  const cpfLimpo = cpf.replace(/\D/g, '');

  // Verificar se o CPF tem 11 dígitos
  if (cpfLimpo.length !== 11) {
    return false;
  }

  // Verificar se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cpfLimpo)) {
    return false;
  }

  // Calcular o primeiro dígito verificador
  let soma = 0;

  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpfLimpo.charAt(i)) * (10 - i);
  }

  let resto = 11 - (soma % 11);
  const digito1 = resto >= 10 ? 0 : resto;

  // Verificar se o primeiro dígito verificador está correto
  if (digito1 !== parseInt(cpfLimpo.charAt(9))) {
    return false;
  }

  // Calcular o segundo dígito verificador
  soma = 0;

  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpfLimpo.charAt(i)) * (11 - i);
  }

  resto = 11 - (soma % 11);
  const digito2 = resto >= 10 ? 0 : resto;

  // Verificar se o segundo dígito verificador está correto
  if (digito2 !== parseInt(cpfLimpo.charAt(10))) {
    return false;
  }

  // CPF válido
  return true;
}
